import React, { useState, useEffect, useCallback } from 'react'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { Layout, Table } from 'antd'
import AntdProvider from '../../components/AntdProvider'
import { fetchDeleteRecords } from '../../actions/photo'
import CONFIG from '../../constants/config'
import { capturePromiseException } from '../../utils/sentryUtils'

import PageHeader from '@/components/PageHeader'
const { Content } = Layout
const { Column } = Table

// 删除记录类型
interface DeleteRecord {
  operUserName: string
  userRole: number
  operType: string
  deleteCount: number
  operTime: string
}

function DeleteRecords() {
  const dispatch = useAppDispatch()
  const groupId = useAppSelector((state) => state.group.groupId)

  const [records, setRecords] = useState<DeleteRecord[]>([])
  const [pageNO, setPageNO] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [totalCount, setTotalCount] = useState(0)

  const handleFetchDeleteRecords = useCallback(() => {
    dispatch(fetchDeleteRecords({ groupID: groupId, pageNO, pageSize }))
      .then((data) => {
        setRecords(data.payload.payload)
        setTotalCount(data.payload.totalCount)
      })
      .catch(capturePromiseException)
  }, [dispatch, groupId, pageNO, pageSize])

  useEffect(() => {
    handleFetchDeleteRecords()
  }, [handleFetchDeleteRecords])

  const dataSource = records.map((record, index) => ({
    ...record,
    key: index + 1
  }))

  return (
    <Layout className="Photo">
      <PageHeader className="Header" ghost={false} title="删除记录" />
      <Content className="content" style={{ padding: '20px' }}>
        <Table
          rowKey="key"
          scroll={{
            y: window.innerHeight - 240,
            scrollToFirstRowOnChange: true
          }}
          pagination={{
            total: totalCount,
            current: pageNO,
            pageSize: pageSize,
            onChange: (page, newPageSize) => {
              setPageNO(page)
              setPageSize(newPageSize)
            }
          }}
          dataSource={dataSource}
        >
          <Column dataIndex="key" title="序号" />
          <Column dataIndex="operUserName" title="操作成员" />
          <Column
            dataIndex="userRole"
            title="角色"
            render={(text, record: DeleteRecord & { key: number }) =>
              CONFIG.memberRoles.find(
                (memberRole) => memberRole.id === record.userRole
              )?.role ?? '-'
            }
          />
          <Column dataIndex="operType" title="操作类型" />
          <Column dataIndex="deleteCount" title="数量" />
          <Column dataIndex="operTime" title="操作时间" />
        </Table>
      </Content>
    </Layout>
  )
}

// 使用 AntdProvider 包裹页面组件
const DeleteRecordsPage = () => (
  <AntdProvider>
    <DeleteRecords />
  </AntdProvider>
)

export { DeleteRecords }
export default DeleteRecordsPage
